import React from "react";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { Container } from "react-bootstrap";
import "./Header.css";

function Header() {
  return (
    <div className="header-wrapper">
      <Container>
        <Navbar expand="lg" className="header">
          <Navbar.Brand href="/" className="ms-3">
            <img
              src="/assets/images/logo.png"
              alt="Logo"
              className="header-logo"
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse
            id="basic-navbar-nav"
            className="justify-content-between"
          >
            <Nav className="ms-auto">
              <Nav.Link href="/">Home</Nav.Link>
              <Nav.Link href="/About">About</Nav.Link>
              <NavDropdown title="Building" id="building-dropdown">
                <NavDropdown.Item href="/Commercial">
                  Commercial
                </NavDropdown.Item>
                <hr className="header-hr" />
                <NavDropdown.Item href="/Residential">
                  Residential
                </NavDropdown.Item>
              </NavDropdown>
              <NavDropdown title="Engineering" id="engineering-dropdown">
                <NavDropdown.Item href="/Structural">
                  Structural
                </NavDropdown.Item>
                <hr className="header-hr" />
                <NavDropdown.Item href="/Civil">Civil</NavDropdown.Item>
              </NavDropdown>
              <NavDropdown title="Architecture" id="architecture-dropdown">
                <NavDropdown.Item href="/Interior">Interior</NavDropdown.Item>
                <hr className="header-hr" />
                <NavDropdown.Item href="/Exterior">Exterior</NavDropdown.Item>
                <hr className="header-hr" />
                <NavDropdown.Item href="/Landscaping">
                  Landscaping
                </NavDropdown.Item>
                <hr className="header-hr" />
                <NavDropdown.Item href="/Vastu">
                  Vastu Insights
                </NavDropdown.Item>
              </NavDropdown>
              <NavDropdown title="Management" id="management-dropdown">
                <NavDropdown.Item href="/Project">Project</NavDropdown.Item>
                <hr className="header-hr" />
                <NavDropdown.Item href="/Site">Site</NavDropdown.Item>
              </NavDropdown>
              <Nav.Link href="/Contact" className="me-3">
                Contact
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </Container>
    </div>
  );
}

export default Header;
